import kotakUpiQr from "../assets/payment/kotak-upi-qr.png";

export const TUITION_PAYMENT_CONFIG = {
  payeeName: "ABHISHEK HULAGADDI",
  upiId: "7795382064@kotakbank",
  bankName: "Kotak 811",
  currency: "INR",
  paymentNote: "Book My Tuitions fee",
  defaultAmount: 2000,
  minimumMonthsCharge: 3,
  platformFeePercent: 10,
  qrCodeImage: kotakUpiQr,
};

export const buildUpiPaymentUri = (amount, tuitionId) =>
  `upi://pay?pa=${encodeURIComponent(TUITION_PAYMENT_CONFIG.upiId)}&pn=${encodeURIComponent(TUITION_PAYMENT_CONFIG.payeeName)}&am=${amount}&cu=${TUITION_PAYMENT_CONFIG.currency}&tn=${encodeURIComponent(`${TUITION_PAYMENT_CONFIG.paymentNote} #${tuitionId}`)}`;

export const resolvePaymentAmount = (tuition) => {
  const amount = Number(tuition?.paymentAmount);
  return Number.isFinite(amount) && amount > 0
    ? amount
    : TUITION_PAYMENT_CONFIG.defaultAmount;
};

export const getFeeSplit = (paymentAmount) => {
  const total = Number(paymentAmount);
  if (!Number.isFinite(total) || total <= 0) {
    return { total: 0, platformFees: 0, tutorFees: 0 };
  }
  const platformFees = Math.round(
    (total * TUITION_PAYMENT_CONFIG.platformFeePercent) / 100,
  );
  return {
    total,
    platformFees,
    tutorFees: total - platformFees,
  };
};

export const formatFeeAmount = (amount) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) {
    return "—";
  }
  return `₹${value.toLocaleString("en-IN")}`;
};

export const getPaymentConfigForTuition = (tuition) => {
  const amount = resolvePaymentAmount(tuition);
  const tuitionId = tuition?.tuitionId || "";
  const upiPaymentUri = buildUpiPaymentUri(amount, tuitionId);

  return {
    ...TUITION_PAYMENT_CONFIG,
    amount,
    upiPaymentUri,
    qrCodeUrl: TUITION_PAYMENT_CONFIG.qrCodeImage,
  };
};

export const formatPaymentStatus = (status) => {
  if (!status) return "Pending";
  return status
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatPaymentDate = (dateValue) => {
  if (!dateValue) return null;
  const parts = String(dateValue).split("-");
  const date =
    parts.length === 3
      ? new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]))
      : new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

/** Next due date from API, or fallback for older verified tuitions. */
export const resolveNextPaymentDueDate = (tuition) => {
  if (tuition?.nextPaymentDueDate) {
    return tuition.nextPaymentDueDate;
  }
  if (!isTuitionPaymentVerified(tuition)) {
    return null;
  }
  // Paid cycle ends at tuitionEndDate; that is the next renewal due date.
  if (tuition?.tuitionEndDate) {
    return tuition.tuitionEndDate;
  }
  const months = TUITION_PAYMENT_CONFIG.minimumMonthsCharge;
  const base = tuition?.paymentVerifiedAt || tuition?.tuitionStartDate;
  if (!base) return null;
  const parts = String(base).split("-");
  if (parts.length !== 3) return null;
  const date = new Date(
    Number(parts[0]),
    Number(parts[1]) - 1,
    Number(parts[2]),
  );
  date.setMonth(date.getMonth() + months);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const isTuitionPaymentVerified = (tuition) =>
  tuition?.paymentVerified === true || tuition?.paymentStatus === "VERIFIED";

export const tuitionNeedsPayment = (tuition) => {
  if (!tuition || isTuitionPaymentVerified(tuition)) {
    return false;
  }
  if (tuition.paymentStatus === "SUBMITTED") {
    return false;
  }
  return ["AWAITING_PAYMENT", "PLANNED"].includes(tuition.tuitionStatus);
};

export const canSubmitTuitionPayment = (tuition) => {
  if (!tuition || isTuitionPaymentVerified(tuition)) {
    return false;
  }
  if (tuition.paymentStatus === "SUBMITTED") {
    return false;
  }
  const payableStatus = ["AWAITING_PAYMENT", "PLANNED"].includes(
    tuition.tuitionStatus,
  );
  const payablePaymentStatus =
    !tuition.paymentStatus ||
    ["PENDING", "REJECTED"].includes(tuition.paymentStatus);
  return payableStatus && payablePaymentStatus;
};
